import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header.vue'
import Sidebar from './Sidebar/Sidebar.vue'
// import Switch from './CSwitch.vue'

export {
  Aside,
  Breadcrumb,
  Callout,
  Footer,
  Header,
  Sidebar,
  // CSwitch
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js